module.exports = __webpack_public_path__ + "img/cafes-chain-dark.3e9bcf89.svg";